module.exports = __webpack_public_path__ + "img/Europe_1_logo_(2010).c33493a7.svg";